import { Cookies } from 'react-cookie'

type Props = {
  token: string
  options?: {
    path: string
  }
}

const NINETY_DAYS = 1000 * 60 * 60 * 24 * 90
export const authCookieName = `_unicityToken_v5`

export const setAuthCookie = ({ token, options = { path: '/' } }: Props) => {
  if (typeof window === 'undefined') {
    throw new TypeError(
      'Cookies.js::This method can only be called in the Client/browser',
    )
  }

  const cookieInstance = new Cookies()
  const now = Date.now()
  const expires = new Date(now + NINETY_DAYS)

  const cookieOptions = { secure: true, expires, ...options }

  cookieInstance.set(authCookieName, token, cookieOptions)
}
